import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DashboardLayout } from './pages/DashboardLayout';
import { LoginPage } from './pages/LoginPage';
import { Overview } from './pages/Overview';
import { TechnicalDashboard } from './pages/TechnicalDashboard';
import { SystemDetails } from './pages/SystemDetails';
import { BillingDashboard } from './pages/BillingDashboard';
import { BillingSystemDetails } from './pages/BillingSystemDetails';
import { UserManagement } from './pages/UserManagement';
import { RoleManagement } from './pages/RoleManagement';
import { ServicesManagement } from './pages/ServicesManagement';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-0">
        Loading...
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-1" />;
  }
  return <>{children}</>;
}
export function App() {
  return <AuthProvider data-id="element-2">
      <Router data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/login" element={<LoginPage data-id="element-6" />} data-id="element-5" />

          <Route path="/" element={<ProtectedRoute data-id="element-8">
                <DashboardLayout data-id="element-9" />
              </ProtectedRoute>} data-id="element-7">
            <Route index element={<Overview data-id="element-11" />} data-id="element-10" />

            {/* Technical Routes */}
            <Route path="technical" element={<TechnicalDashboard data-id="element-13" />} data-id="element-12" />
            <Route path="technical/:id" element={<SystemDetails data-id="element-15" />} data-id="element-14" />

            {/* Billing Routes */}
            <Route path="billing" element={<BillingDashboard data-id="element-17" />} data-id="element-16" />
            <Route path="billing/:id" element={<BillingSystemDetails data-id="element-19" />} data-id="element-18" />

            {/* Management Routes */}
            <Route path="users" element={<UserManagement data-id="element-21" />} data-id="element-20" />
            <Route path="roles" element={<RoleManagement data-id="element-23" />} data-id="element-22" />
            <Route path="services" element={<ServicesManagement data-id="element-25" />} data-id="element-24" />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-27" />} data-id="element-26" />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>;
}